import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {AlertService} from '../../../services/alert.service';
import {BancoldexService} from '../../../comun/services/bancoldex.service';
import {ComisionesService} from '../../Service/comisiones.service';
import {RouterService} from '../../../services/router.service';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
declare var $: any;
@Component({
    selector: 'app-ver-detalle-comision',
    templateUrl: './ver-detalle-comision.component.html',
    styleUrls: ['./ver-detalle-comision.component.scss'],
    standalone: false
})
export class VerDetalleComisionComponent implements OnInit {

  totalPaginas: number = 1;
  paginaActual: number = 0;
  comisionesForm: UntypedFormGroup;
  listaSolicitudes: any[] = [];
  listaSolicitudesCuenta: any[] = [];
  solicitudCuentaCobroSeleccionada: any[] = [];
  public idCuenta: Number = null;
  solicitudesCuenta: any[] = [];
  reasignarSolicitudCuentaForm: UntypedFormGroup;
  motivo: any;
  estado: any;
  nombreCampo: any;
  nombreCliente: any;
  valorTotal: any;
  @Input() data: any;

  constructor(
    public router: Router,
    private _route: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private alertService: AlertService,
    private _bancoldexService: BancoldexService,
    private comisionService: ComisionesService,
    private _routerService: RouterService,
    private _sweetAlert:SweetAlertService
  ) { }

  ngOnInit(): void {
    this._route.params.subscribe((params: Params) => {
      this.idCuenta = params['id'];
    });
    this.getSolicitudes();
    this.obtenerMotivo();
    this.estado = this.comisionService.getData();
    if (this.estado === 'DEVUELTA REVISOR') {
      this.nombreCampo = 'devolución';
    }
    if (this.estado === 'ANULADA') {
      this.nombreCampo = 'anulación';
    }
  }

  validarCheckbox(event, i){
    this.solicitudCuentaCobroSeleccionada[i] = event.target.checked;
  }

  getSolicitudes(){
    this._bancoldexService.getSolicitudes(this.idCuenta).subscribe(
      (response) => {
        this.listaSolicitudes = response['data'];
        this.totalPaginas = response['paginasTotales'];
        this.paginaActual = response['paginaActual'];
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,
          'No fue posible cargar las solicitudes'
        );
      }
    );
  }

  goBack() {
    this._routerService.goBack();
  }

  aceptar() {
    $('#aceptar').modal('hide');
    this.router.navigate(['bancoldex/administracion/mensajesInformativos']);
  }

  selectPage(pageNumber: number){
    this.comisionesForm.get('pagina').setValue(pageNumber);
    this.ngOnInit();
  }

  pages(){
    return new Array(this.totalPaginas);
  }

  obtenerMotivo() {
    this.comisionService.obtenerJustificacion(this.idCuenta).subscribe((resp: any) => {
      if (resp.exitoso){
        if (this.estado === 'DEVUELTA REVISOR'){
          this.motivo = resp.motivoNegacion;
        }

        if (this.estado === 'ANULADA'){
          this.motivo = resp.motivoAnulacion;
        }
      }
      this.nombreCliente = resp.nombreCliente;
      this.valorTotal = resp.valorTotal;
    });
  }

}
